import { Component, input, model } from '@angular/core';

@Component({
  selector: 'bt-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css'],
  standalone: false,
})
export class ToggleComponent {
  active = model<boolean>(false);

  ionIcon = input<string>('pi-check-square');

  description = input<string>();
  label = input<string>();

  toggleOnly = input<boolean>(true);

  activeText = input<string>();
  nonActiveText = input<string>();

  toggle() {
    this.active.update((v) => !v);
  }
}
